import { useState, useEffect, useRef, useCallback } from 'react';
import { WEBHOOK_ORDER_STATUS, POLLING_INTERVAL } from '../data/constants';

export const useCounterState = () => {
  const [sales, setSales] = useState({ esquerda: 0, direita: 0 });
  const [changedSide, setChangedSide] = useState(null); // 'esquerda' | 'direita' | null
  const prevSalesRef = useRef({ esquerda: 0, direita: 0 });

  const fetchSalesData = useCallback(async () => {
    try {
      const response = await fetch(WEBHOOK_ORDER_STATUS);
      if (!response.ok) throw new Error('Erro ao buscar dados');

      const result = await response.json();
      if (!result.success) return;

      const salesData = { esquerda: 0, direita: 0 };
      result.data.by_book_type.forEach(item => {
        salesData[item.book_type] = parseInt(item.count, 10);
      });

      // Detecta qual lado mudou para disparar animação externa
      const prev = prevSalesRef.current;
      if (salesData.esquerda !== prev.esquerda) {
        setChangedSide('esquerda');
      } else if (salesData.direita !== prev.direita) {
        setChangedSide('direita');
      }

      prevSalesRef.current = salesData;
      setSales(salesData);
    } catch (error) {
      console.error('❌ Erro ao carregar vendas:', error);
      // Mantém último valor — não reseta para zero em caso de falha
    }
  }, []);

  useEffect(() => {
    fetchSalesData(); // Busca imediata no mount
    const interval = setInterval(fetchSalesData, POLLING_INTERVAL);
    return () => clearInterval(interval);
  }, [fetchSalesData]);

  const incrementSales = useCallback((bookType) => {
    setSales(prev => ({ ...prev, [bookType]: prev[bookType] + 1 }));
  }, []);

  // Reseta changedSide após ser consumido pelo index.js
  const clearChangedSide = useCallback(() => setChangedSide(null), []);

  return { sales, setSales, incrementSales, changedSide, clearChangedSide };
};
